import FAQAccordion from '@/components/base/FAQAccordion';

export const faqItems = [
  {
    q: 'O que é carpete modular?',
    a: 'É um sistema de revestimento de piso composto por placas que são assentadas de forma individual. Ele permite compor paginações, cores e padrões, e é amplamente utilizado em projetos corporativos pela praticidade de aplicação e manutenção.',
  },
  {
    q: 'Carpete em placa é indicado para escritório?',
    a: 'Sim. O carpete em placas é uma solução comum em escritórios, salas de reunião e áreas de trabalho, por unir conforto, desempenho e a possibilidade de intervenções localizadas em áreas de maior circulação.',
  },
  {
    q: 'Qual a vantagem do carpete para ambientes corporativos?',
    a: 'Além da estética, o carpete contribui para o conforto da superfície e ajuda a reduzir reflexões sonoras e ruídos de passos, criando um ambiente de trabalho mais agradável. A modularidade também facilita a manutenção pontual, dependendo do sistema.',
  },
  {
    q: 'Carpete ajuda na acústica?',
    a: 'O carpete auxilia na redução de reflexões sonoras e no ruído de passos, o que contribui para o conforto acústico do ambiente. Os resultados variam conforme a linha e o fabricante, e não apresentamos valores quantitativos sem documentação técnica do produto.',
  },
  {
    q: 'É possível trocar somente algumas placas?',
    a: 'Em sistemas modulares, geralmente é possível substituir apenas as placas que apresentarem desgaste ou dano, o que facilita a manutenção localizada. Essa possibilidade depende do produto escolhido e das condições de instalação.',
  },
  {
    q: 'O contrapiso precisa de preparação?',
    a: 'Sim. As condições do contrapiso são analisadas caso a caso. A preparação adequada da base é essencial para o desempenho e a durabilidade do piso, e avaliamos essa etapa dentro de cada projeto.',
  },
  {
    q: 'Como calcular a quantidade de carpete?',
    a: 'A quantidade é calculada a partir do levantamento da área e da definição da paginação. Consideramos perdas de recorte, sentido de assentamento e eventuais ajustes de perímetro. Esse cálculo faz parte do nosso projeto.',
  },
  {
    q: 'A Home Office Premium faz a instalação?',
    a: 'Sim. Atuamos na especificação, fornecimento e instalação de carpete corporativo, coordenando a implantação de ponta a ponta.',
  },
  {
    q: 'Vocês atendem projetos fora de Caruaru?',
    a: 'Sim. Atendemos projetos corporativos em Pernambuco e avaliamos projetos em todo o Nordeste conforme porte e logística.',
  },
  {
    q: 'Vocês trabalham junto com arquitetos?',
    a: 'Sim. Executamos e fornecemos soluções de acordo com a especificação do profissional, integrando o carpete ao projeto de arquitetura e aos demais elementos do ambiente.',
  },
];

export default function FaqSection() {
  return (
    <section className="bg-white">
      <div className="max-w-[1200px] mx-auto px-5 md:px-8 py-20 md:py-28">
        <div className="max-w-2xl mb-12">
          <p className="text-[12px] md:text-[13px] font-semibold tracking-[0.28em] uppercase text-primary-500 mb-4">
            Perguntas frequentes
          </p>
          <h2 className="text-foreground-950 text-[28px] md:text-[38px] font-semibold tracking-tight leading-tight">
            Carpete corporativo, sem mistério.
          </h2>
        </div>

        <div className="max-w-3xl">
          {faqItems.map((f) => (
            <FAQAccordion key={f.q} question={f.q} answer={f.a} />
          ))}
        </div>
      </div>
    </section>
  );
}